import { useEffect } from 'react';

import {
  getApplicationGlobals,
  updateTrackingConfig,
  updateDatadogGlobals,
} from './trackingConfig';
import type { TTrackingConfig } from './types';

interface TDataDogGlobalsData {
  appType: TTrackingConfig['APP_TYPE'];
  allowAudioTracksSelector?: boolean | null;
  isUserInAudioTrackSelectorTest?: boolean | null;
  modalLocation?: string | null;
  pageName?: string | null;
  userId?: number | null;
  videoId?: string | null;
  userLocale?: string | null;
  sessionId?: string | null;
}

export function useDataDogGlobals(
  {
    appType,
    modalLocation = null,
    pageName = null,
    userId = null,
    userLocale = null,
    videoId = null,
    allowAudioTracksSelector = null,
    isUserInAudioTrackSelectorTest = null,
  }: TDataDogGlobalsData,
  appendTagToGlobals: boolean = true,
) {
  useEffect(() => {
    updateTrackingConfig({
      APP_TYPE: appType,
      USER_ID: userId,
      USER_LOCALE: userLocale,
      MODAL_LOCATION: modalLocation,
      PAGE_NAME: pageName,
      VIDEO_ID: videoId,
      ALLOW_AUDIOTRACK_SELECTOR: allowAudioTracksSelector,
      IS_AB_TEST: isUserInAudioTrackSelectorTest,
    });

    if (appendTagToGlobals) {
      updateDatadogGlobals(getApplicationGlobals());
    }
  }, [
    appType,
    appendTagToGlobals,
    modalLocation,
    pageName,
    userId,
    userLocale,
    videoId,
    allowAudioTracksSelector,
    isUserInAudioTrackSelectorTest,
  ]);
}
